import React, { useEffect, useState } from "react";
import { Route, Routes, useParams } from "react-router-dom";

import UserFormPage from "@/components/screens/UserFormPage";
import Users from "@/components/screens/Users";
import { USERS_MESSAGES, type UsersMessages } from "@/messages/users/user.messages";
import translationService from "@/services/translation.service";
import { type Language, type Translation } from "@/types/language.types";

const UsersPage: React.FC = () => {
  const { lang = "PT-BR" } = useParams();
  const [messages, setMessages] = useState<Translation<UsersMessages> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const usersTranslations = await translationService.get<UsersMessages>(
          USERS_MESSAGES,
          (lang as Language) ?? null
        );
        setMessages(usersTranslations);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return null; // Loading handled by Suspense in child components
  }

  if (!messages) {
    return <div>Erro ao carregar mensagens</div>;
  }

  return (
    <Routes>
      <Route path=":lang" element={<Users messages={messages} />} />
      <Route path="/create/:lang" element={<UserFormPage messages={messages} />} />
      <Route path="/update/:userId/:lang" element={<UserFormPage messages={messages} />} />
      <Route path="/" element={<Users messages={messages} />} />
    </Routes>
  );
};

export default UsersPage;
